import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { BlockConfig } from '../../../BlockConfig';
import { ThemeContext } from 'styled-components';
import { DESKTOP_BREAKPOINTS, useBreakpoint } from '../../../../utils/react/useBreakpoint';
const StyledImage = styled.img`
  max-width: 100%;
  max-height: 100%;

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex: 0 0 auto;
  }

  &&&& {
    ${({
  mobileMarginOffset,
  theme
}) => `@media (max-width: ${theme.breakpoints.md}) {
        margin-left: ${mobileMarginOffset};
    }`}
  }

  &&& {
    align-self: flex-start;
    ${({
  tabletMarginOffset
}) => `margin-left: ${tabletMarginOffset};`}
  }
`;
const StyledBlockConfig = styled(BlockConfig)`
  /* This code is for ie11 and nested mediaquery issue */
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    ${({
  ieFlexFix
}) => ieFlexFix ? `flex: 0 0 auto !important;` : ''};
  }
`;
export const ImageBlock = ({
  className,
  image,
  mobileConfig,
  tabletConfig
}) => {
  const theme = useContext(ThemeContext);
  const [ieFlexFix, setIeFlexFix] = useState(false);
  /* This code is for ie11 and nested mediaquery issue */

  const breakpoint = useBreakpoint();
  useEffect(() => {
    setIeFlexFix(!DESKTOP_BREAKPOINTS.includes(breakpoint));
  }, [breakpoint]);
  const mobileConfigWithDefault = { ...(mobileConfig || {}),
    marginBottom: (mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.marginBottom) || '4',
    preferredWidth: (mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.preferredWidth) || `auto`
  };
  const tabletConfigWithDefault = { ...(tabletConfig || {}),
    marginBottom: (tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.marginBottom) || '4',
    preferredWidth: (tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.preferredWidth) || `auto`
  };
  let mobileMarginOffset = '0';

  if (mobileConfig !== null && mobileConfig !== void 0 && mobileConfig.marginLeft) {
    let num = Number(mobileConfig.marginLeft);

    if (num < 0) {
      num = num / 2;
      mobileMarginOffset = theme.xSpace[`${num * -1}`];
    }
  }

  let tabletMarginOffset = '0';

  if (tabletConfig !== null && tabletConfig !== void 0 && tabletConfig.marginLeft) {
    let num = Number(tabletConfig.marginLeft);

    if (num < 0) {
      num = num / 2;
      tabletMarginOffset = theme.xSpace[`${num * -1}`];
    }
  }

  return image ? /*#__PURE__*/React.createElement(StyledBlockConfig, {
    className: className,
    mobileConfig: mobileConfigWithDefault,
    tabletConfig: tabletConfigWithDefault,
    ieFlexFix: ieFlexFix
  }, /*#__PURE__*/React.createElement(StyledImage, {
    alt: image.title || 'Unnamed Image',
    src: `${image.url}`,
    mobileMarginOffset: mobileMarginOffset,
    tabletMarginOffset: tabletMarginOffset
  })) : null;
};